import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'phone'})
export class TransformPhonePipe implements PipeTransform {
  transform(value: number) {
        return this.parsePhone(value);
  }
  parsePhone(value) {
    return value.substring(0, 2) + ' ' + value.substring(3, 5) +  ' ' + value.substring(6, 8)
  }
}